import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as STATES from 'src/assets/states.json';
import { Observable } from 'rxjs';
import { ViaCepService } from 'src/services/via-cep.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-company-account',
  templateUrl: './company-account.component.html',
  styleUrls: ['./company-account.component.scss']
})
export class CompanyAccountComponent implements OnInit {

  formUser: FormGroup;
  formCompany: FormGroup;
  currentUser: any;
  states: Array<any> = (STATES as any).default;
  formEditable: boolean = false;
  formCompanyEditable: boolean = false;
  cities$: Observable<any>;

  constructor(
    private viaCep: ViaCepService,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private fb: FormBuilder
  ) {

    this.currentUser = JSON.parse(localStorage.getItem('token'));
    this.formUser = this.fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      email: [null, [Validators.required, Validators.required]],
      cpf: [null, [Validators.required, CustomValidators.cpf]],
      phone: [null, [Validators.required, CustomValidators.phone]],
      gender: [null, Validators.required],
      birthday: [null, Validators.required],
      zipCode: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      district: [null, Validators.required],
      street: [null, Validators.required],
      number: [null, Validators.required],
      complement: [null]
    })

    this.formCompany = fb.group({
      id: [null, Validators.required],
      businessName: [null, Validators.required],
      companyName: [null, Validators.required],
      cnpj: [null, [Validators.required, CustomValidators.cnpj]],
      ie: [null],
      im: [null],
      taxRegime: [null, Validators.required],
      zipCode: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      street: [null, Validators.required],
      district: [null, Validators.required],
      number: [856, Validators.required],
      complement: [null],
      email: [null, [Validators.required, Validators.email]],
      site: [null],
      facebook: [null],
      instagram: [null],
      youtube: [null],
      companyphone: [null, [Validators.required, CustomValidators.phone]],
    })

  }

  ngOnInit(): void {
    this.getAccount();

    this.http.get('profile', { id: this.currentUser.id })
      .subscribe(
        (result: any) => {

          const { type, data } = result;
          if (type === 'OK') {
            for (const key in data) {
              const value = data[key];
              if (value === 'undefined')
                data[key] = null;
            }

            if (data.city !== null && data.city.split(',').length > 1) {
              var uf = data.city?.split(',')[1].trim() ?? '';
              var cidade = data.city?.split(',')[0].trim() ?? '';
              var estado = this.states.find(estado => estado.sigla.trim() === uf);
            } else {
              var estado = data.state;
              var cidade = data.city;
            }

            this.formUser.patchValue(
              {
                firstname: data.firstname,
                lastname: data.lastname,
                cpf: data.cpf,
                phone: data.phone,
                gender: data.gender,
                birthday: data.birthdate,
                zipCode: data.zipcode,
                state: estado,
                city: cidade,
                district: data.district,
                street: data.address1,
                number: data.address2,
                complement: data.complement,
                email: data.email
              },
              { emitEvent: false }
            );

          }

        }
      )

    this.formCompany.get('state')
      .valueChanges
      .subscribe(
        state => {
          this.cities$ = this.http.list('locality:city', { initials: state.sigla });
        }
      )

    this.formUser.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {

          if (!this.formUser.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {

                  const { bairro, localidade, logradouro, uf } = data;
                  this.formUser.patchValue({
                    district: bairro,
                    city: localidade,
                    street: logradouro,
                    state: uf,
                    //email: localStorage.getItem('email')
                  });
                }
              )
          }
        }
      )

    this.formCompany.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {

          if (!this.formCompany.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {
                 
                  const { bairro, localidade, logradouro, uf } = data;
                  this.formCompany.patchValue({
                    district: bairro,
                    city: localidade,
                    street: logradouro,
                    state: this.states.find(estado => estado.sigla.trim() === uf)
                  });
                }
              )
          }
        }
      )

    this.formUser.get('cpf')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cpf => {

          if (!this.formUser.get('cpf').invalid) {
            const params = {
              cpf: cpf.replace(/[^0-9]/gmi, ''),
              accountType: 'company'
            }

            this.http.get('data_validation:cpf', params)
              .subscribe(
                (result: any) => {
                  const { type } = result;
                  if (type === 'ALREAD_EXIST') {
                    this.formUser.get('cpf').setErrors({ alread: true });
                  }
                }
              )
          }
        }
      );

    this.formUser.get('phone')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        phone => {

          if (!this.formUser.get('phone').invalid) {
            const params = {
              phone: phone.replace(/[^0-9]/gmi, ''),
              accountType: 'company'
            }

            this.http.get('data_validation:phone', params)
              .subscribe(
                (result: any) => {
                  const { type } = result;
                  if (type === 'ALREAD_EXIST') {
                    this.formUser.get('phone').setErrors({ alread: true });
                  }
                }
              )
          }
        }
      );

    this.formUser.get('email')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        email => {

          if (!this.formUser.get('email').invalid) {
            const params = {
              email: email.replace(/[^0-9]/gmi, ''),
              accountType: 'company'
            }

            this.http.get('data_validation:phone', params)
              .subscribe(
                (result: any) => {
                  const { type } = result;
                  if (type === 'ALREAD_EXIST') {
                    this.formUser.get('email').setErrors({ alread: true });
                  }
                }
              )
          }
        }
      );

  }

  public editable(edit: boolean = true) {

    this.formEditable = edit;
    if (!edit)
      this.formUser.markAsPristine();

  }

  public editableCompany(edit: boolean = true) {

    this.formCompanyEditable = edit;
    if (!edit)
      this.formCompany.markAsPristine();

  }

  public getAccount() {

    this.http.list('company', { id: this.currentUser.company_id })
      .subscribe(
        (result: any) => {
          const { data } = result;
         
          for (const key in data) {

            const value = data[key];
            if (value === 'undefined')
              data[key] = null;

          }

          if (data.companycity && data.companycity.split(',').length > 1) {
            var uf = data.companycity?.split(',')[1].trim() ?? '';
            var cidade = data.companycity?.split(',')[0].trim() ?? '';
            var estado = this.states.find(estado => estado.sigla.trim() === uf);
            this.cities$ = this.http.list('locality:city', { initials: uf });
          } else {
            var estado =  this.states.find(estado => estado.sigla.trim() === data.companystate);
            var cidade = data.companycity;
            this.cities$ = this.http.list('locality:city', { initials: data.companystate });
          }

          this.formCompany.patchValue(
            {
              id: this.currentUser.company_id,
              businessName: data.businessname,
              companyName: data.companyname,
              cnpj: data.cnpj,
              ie: data.ie,
              im: data.im,
              taxRegime: data.tax_regime,
              zipCode: data.companyzipcode,
              state: estado,
              city: cidade,
              street: data.companyaddress1,
              district: data.district,
              number: data.companyaddress2,
              complement: data.complement,
              email: data.companyemail,
              site: data.companywebsite,
              facebook: data.facebook,
              instagram: data.instagram,
              youtube: data.youtube,
              companyphone: data.companyphone
            },
            { emitEvent: false }
          );
        },
        err => this.errorReport.showMessage(err)
      )

  }

  submit() {

    const isValid = !this.formUser.invalid;
    const data = this.formUser.getRawValue();

    if (isValid) {

      this.http.save('profile', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.snackbar.open('Atualização salva com sucesso!', 'OK', { duration: 3000 });
              this.editable(false);
            } else
              this.snackbar.open('Desculpe não foi possivel salvar alteração, tente novamente!', 'OK', { duration: 3000 });

          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  submitCompany() {

    const isValid = !this.formCompany.invalid;
    const data = this.formCompany.getRawValue();

    data.state = data.state.sigla;

    if (isValid) {

      this.http.save('company', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.snackbar.open('Atualização salva com sucesso!', 'OK', { duration: 3000 });
              this.editableCompany(false);
            }
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  public excluir_conta() {

    if (!confirm('Deseja realmente excluir sua conta e todos os dados relacionado a ela? Essa ação não poderá ser desfeita'))
      return false;

    const data = this.formCompany.getRawValue();
    const user = JSON.parse(localStorage.getItem('token'));

    data.id_user = user.id;

    this.http.save('company:remove', data)
      .subscribe(
        (result: any) => {
          // console.log(result);
          if (result.type === 'OK') {

            this.snackbar.open('Conta removida com sucesso!', 'OK', { duration: 3000 });
            localStorage.removeItem('token');
            localStorage.clear();
            setTimeout(() => window.location.reload(), 4000);

          } else
            this.snackbar.open('Desculpe não foi possível excluir a conta, por favor tente novamente!', 'OK', { duration: 3000 });
        },
        err => this.errorReport.showMessage(err)
      )


  }


}
